import * as filterHeaderTypes from '../webcommon/header/filterheader/propTypes';
import { lastWorkingDay } from '../common/helpermethods/HelperMethods';
import { getTimeStamp } from '../webcommon/common/helpers';


export const statusPageColumns = [
    {
        Header: 'Server Name',
        id: 'server'
    },
    {   
        Header: 'Status',
        id : 'status'
    },
    {
        Header: 'TimeStamp',
        id: 'timeStamp'
    }
]
export const userProfileColumns = [
    {
        Header: 'User Name',
        id: 'userName'
    },
    {   
        Header: 'Email Address',
        id : 'email'
    }
]

export const userRoleColumns = [
    {
        Header: 'Roles',
        id: 'role'
    }
]

export const statusPageDefaultRow = [
    {
        server: 'Unknown Server'
    },
    {   
        status: 'Not Connected!'
    },
    {
        timeStamp: getTimeStamp()
    }
]
